/**
 * Meta CV Button Shortcode Parser
 *
 * ページのリッチテキストエディタ内に記述したショートコードを
 * クリック時に Meta Purchase イベントを発火するボタンに変換する。
 *
 * ショートコード記法:
 *   [meta-cv-button url="リンク先URL"]
 *   [meta-cv-button label="ボタンテキスト" url="リンク先URL"]
 *
 * パラメータ:
 *   url    {必須} リダイレクト先URL（Amazon / 楽天 等）
 *   label  {省略可} ボタンテキスト。省略時: "購入する"
 *   bg     {省略可} ボタン背景色。CSS色指定（例: "#ff6600", "red"）
 *   color  {省略可} ボタンテキスト色。CSS色指定（例: "#ffffff", "white"）
 *
 * 使用例:
 *   [meta-cv-button label="Amazonで購入する" url="https://www.amazon.co.jp/dp/XXXXXXXXXX/"]
 *   [meta-cv-button label="楽天で購入する" url="https://item.rakuten.co.jp/..." bg="#bf0000" color="#ffffff"]
 */
(function () {
  var CV_EVENT = 'MallTransition';

  // ショートコード全体にマッチする正規表現
  var SC_RE = /^\[meta-cv-button([^\]]*)\]$/;

  // 属性をパース（ストレート引用符・スマート引用符の両方に対応）
  var ATTR_RE = /(\w+)=[\u201c\u201d"]([^\u201c\u201d"]*)[\u201c\u201d"]/g;

  function parseAttrs(attrStr) {
    var attrs = {};
    var m;
    ATTR_RE.lastIndex = 0;
    while ((m = ATTR_RE.exec(attrStr)) !== null) {
      attrs[m[1]] = m[2];
    }
    return attrs;
  }

  function createButton(attrs) {
    var label = attrs.label || '購入する';
    var url   = attrs.url   || '';
    var bg    = attrs.bg    || '';
    var color = attrs.color || '';

    var btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = 'btn btn--primary meta-cv-btn';

    if (bg)    btn.style.backgroundColor = bg;
    if (color) btn.style.color = color;

    var span = document.createElement('span');
    span.className   = 'btn__text';
    span.textContent = label;
    btn.appendChild(span);

    btn.addEventListener('click', function () {
      // Meta Pixel Purchase イベント発火（fbq が未定義の場合はスキップ）
      if (typeof fbq !== 'undefined') {
        try { fbq('track', CV_EVENT); } catch (e) {}
      }
      // 300ms 後にリダイレクト（Pixel ビーコン送信の猶予）
      setTimeout(function () { window.location.href = url; }, 300);
    });

    return btn;
  }

  function replaceShortcodes() {
    var paragraphs = document.querySelectorAll('.rte p, .page__content p');

    paragraphs.forEach(function (p) {
      var text = p.textContent.trim();
      var match = SC_RE.exec(text);
      if (!match) return;

      var attrs = parseAttrs(match[1]);
      if (!attrs.url) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'meta-cv-shortcode';
      wrapper.style.textAlign = 'center';
      wrapper.appendChild(createButton(attrs));

      p.parentNode.replaceChild(wrapper, p);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceShortcodes);
  } else {
    replaceShortcodes();
  }
})();
